import gql from 'graphql-tag';

import { query } from '@/api/graphql';
import GetPermissions from './graphql/queries/GetPermissions.graphql';
import Permission from './graphql/fragments/permission.graphql';

export const fetchPermissions = async () => {
  const { permissions } = await query(gql`
    ${GetPermissions}
    ${Permission}
  `);

  return permissions;
};
